export interface WishlistItem {
  id: string
  user_id: string
  title: string
  description: string | null
  category: string
  size: string | null
  url: string | null
  image_url: string | null
  price: number | null
  original_price: number | null
  color: string | null
  color_text: string | null
  bg_color: string | null
  is_reserved: boolean
  is_hidden: boolean
  is_recurring: boolean
  purchase_count: number
  reserved_by: string | null
  reserved_session_id: string | null
  position: number
  wishlist_id: string | null
  created_at: string
  updated_at: string
}

export type WishlistKind = 'wishlist' | 'guide'

export interface Wishlist {
  id: string
  user_id: string
  title: string
  position: number
  cover_url: string | null
  cover_position?: number
  is_private: boolean
  kind: WishlistKind
  created_at: string
}

export const CATEGORIES = ['Accessori', 'Abbigliamento', 'Arredo casa', 'Tecnologia', 'Gioielli', 'Sport', 'Gift Card'] as const

export interface WishlistCategory {
  id: string
  user_id: string
  name: string
  position: number
  color: string | null
  created_at: string
}

// Ordina le categorie "in uso" seguendo l'ordine personalizzato dell'utente;
// quelle non presenti nella lista custom vanno in coda in ordine alfabetico.
export function orderCategories(inUse: string[], custom: WishlistCategory[]): string[] {
  const order = new Map(custom.map((c) => [c.name, c.position]))
  return [...inUse].sort((a, b) => {
    const pa = order.get(a)
    const pb = order.get(b)
    if (pa != null && pb != null) return pa - pb
    if (pa != null) return -1
    if (pb != null) return 1
    return a.localeCompare(b)
  })
}

export const publicWishlistUrl = (username: string) => `${window.location.origin}/w/${username}`

const slugifyTitle = (title: string) =>
  title
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')

export const boardSlug = (board: Pick<Wishlist, 'title' | 'id'>) => {
  const slug = slugifyTitle(board.title)
  return slug || board.id.slice(0, 8)
}

export const findBoardByParam = (boards: Wishlist[], param: string | null) => {
  if (!param) return null
  const byExact = boards.find((b) => b.id === param || boardSlug(b) === param)
  if (byExact) return byExact
  // Legacy links: "<slug>-<first 8 chars of board id>"
  const legacyMatch = param.match(/^(.*)-([0-9a-f]{8})$/i)
  if (legacyMatch) {
    return boards.find((b) => b.id.startsWith(legacyMatch[2])) ?? null
  }
  return null
}

export const formatPrice = (price: number | null) =>
  price == null
    ? null
    : new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Math.trunc(price))

export const urlHostname = (url: string | null) => {
  if (!url) return null
  try {
    return new URL(url).hostname.replace(/^www\./, '')
  } catch {
    return null
  }
}
